import React, { useState } from "react";
import "../styles/ArticleSection.css";
import { ARTICLE_STEPS, ARTICLE_SUMMARY } from "../utils/travel_esims";

const ArticleSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="article-section">
      <p>{ARTICLE_SUMMARY}</p>
      <div className={`article-content ${!isExpanded ? "content-fade" : ""}`}>
        {ARTICLE_STEPS.map((step, index) => (
          <div key={index} className="step">
            <h3>{step.title}</h3>
            <p>{step.content}</p>
          </div>
        ))}
      </div>
      {!isExpanded && (
        <div className="read-more-container">
          <button
            className="read-more-button"
            onClick={() => setIsExpanded(true)}
            style={{ pointerEvents: "none" }}
          >
            Read more
          </button>
        </div>
      )}
    </div>
  );
};

export default ArticleSection;
